module.exports = __webpack_public_path__ + "images/application/illustrations/sandbox-mode-3c80b9cb.png";